import moment from "moment"
import { useState, useEffect } from "react"
import { useSelector} from 'react-redux'

export default function OrderStaff( { orders, onRowClick, locations, users }) {

  const orderRedux = useSelector(state => state.Order)
  const userRedux = useSelector( state => state.User )
  const authRedux = useSelector( state => state.Auth )
  const locationRedux = useSelector( state => state.Location )
  const [ locationName, setLocationName ] = useState('')

    const onClick = (order) => {
       onRowClick({
           order: order
       })
    }

    console.info( 'orderRedux ?? ', orderRedux)

    useEffect(() => {
      const location = locationRedux.locations.filter( el => el.id == authRedux.user.claims.location )[0]
      
      if ( location && location.name ) {
        console.info( 'location info is ', location.name )
        setLocationName( location.name )
      }
    }, [ locationRedux ])

    const classNames = (...classes) => {
       return classes.filter(Boolean).join(' ')
   }

   const renderLocationInfo = ( locationId ) => {

     const location = locationRedux.locations.filter( el => el.id == locationId )[0]
     
     return location?.name || 'N/A'
   }

   const renderUserInfo = ( userId ) => {
      const user = userRedux.users.filter( el => el.id == userId )[0]

      return user?.name  || 'N/A'
   }

   return orderRedux.isListLoading ? <div className="flex items-center justify-center py-3"><div role="status">
   <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
     <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
   </svg>
   <span class="sr-only">Loading...</span>
 </div> Loading </div>  : <div> 
  <h4 className="py-4 text-xl font-medium"> Orders for location <span className="text-indigo-500"> { locationName } </span> </h4>
  <table className="min-w-full mt-3 border-separate" style={{ borderSpacing: 0 }}>
   <thead className="bg-gray-50">
     <tr>
       <th
         scope="col"
         className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8"
       >
         Date
       </th>
       <th
         scope="col"
         className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8"
       >
         Order #
       </th>
       <th
         scope="col"
         className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8"
       >
         Location
       </th>
       <th
         scope="col"
         className="sticky top-0 z-10 hidden border-b border-gray-300 bg-gray-50 bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter lg:table-cell"
       >
         User
       </th>
       <th
         scope="col"
         className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter"
       >
         Total
       </th>
       <th
         scope="col"
         className="sticky top-0 z-10 border-b border-gray-300 bg-gray-50 bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter"
       >
         Status
       </th>
     </tr>
   </thead>
   <tbody className="bg-white">
     {orderRedux.orders.map((order, personIdx) => (
       <tr key={order.email} onClick={() => onClick(order)} className="cursor-pointer">
         <td
           className={classNames(
             personIdx !== order.length - 1 ? 'border-b border-gray-200' : '',
             'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8 text-left'
           )}
         >
            { moment.unix(order.created_date?.seconds).format('MMMM DD, YYYY') }
         </td>
         <td
           className={classNames(
             personIdx !== order.length - 1 ? 'border-b border-gray-200' : '',
             'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8 text-left'
           )}
         >
            { order.orderNumber }
         </td>
         <td
           className={classNames(
             personIdx !== order.length - 1 ? 'border-b border-gray-200' : '',
             'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8 text-left'
           )}
         >
            { renderLocationInfo( order.buyerDetails.location ) || '-' }
         </td>
         <td
           className={classNames(
             personIdx !== order.length - 1 ? 'border-b border-gray-200' : '',
             'whitespace-nowrap px-3 py-4 text-sm text-gray-500 hidden lg:table-cell text-left'
           )}
         >
            <span className="text-indigo-600">
              { renderUserInfo( order.buyerDetails?.user )}
            </span>
         </td>
         <td
           className={classNames(
             personIdx !== order.length - 1 ? 'border-b border-gray-200' : '',
             'whitespace-nowrap px-3 py-4 text-sm text-gray-500 hidden sm:table-cell text-left'
           )}
         >
           ${Number(order.grandTotal)?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
         </td>
    
         <td
           className={classNames(
             personIdx !== order.length - 1 ? 'border-b border-gray-200' : '',
             order.status === 'pending' ? 'text-orange-500' : '',
             order.status === 'completed' ? 'text-indigo-600' : '',
             order.status === 'submitted' ? 'text-teal-700' : '',
             order.status === 'cancelled' ? 'text-red-500' : '',
             'whitespace-nowrap text-left capitalize font-bold px-3 py-4 text-sm text-gray-500'
           )}
         >
           {order.status}
         </td>
       
       </tr>
     ))}
   </tbody>
  </table>
 </div>
}